import { SocialPath } from "@/models";

import * as Fa from "react-icons/fa";

export const socialData: SocialPath[] = [
  {
    title: "Linkedin",
    path: "https://www.linkedin.com/in/davidangaritaruiz/",
    icon: <Fa.FaLinkedin style={{ color: "#ffffff" }} />,
  },
  {
    title: "Github",
    path: "https://github.com/davidangarita1/",
    icon: <Fa.FaGithub style={{ color: "#ffffff" }} />,
  },
  // {
  //   title: "Youtube",
  //   path: "https://www.youtube.com/channel/UCQAb2ybfJXXR5l8SQhLlAHQ",
  //   icon: <Fa.FaYoutube style={{ color: "#ffffff" }} />,
  // },
];
